import { render } from "./ViewDependentSupport.vue?vue&type=template&id=c2d29d80"
import script from "./ViewDependentSupport.vue?vue&type=script&lang=js"
export * from "./ViewDependentSupport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\ths\\evangelism_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__